import { z } from "zod";

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1, "API base URL is required"),
  VITE_IS_MOCK_API: z
    .string()
    .transform((val) => val === "true")
    .default("false"),
  VITE_APP_NAME: z.string().min(1),
  VITE_APP_VERSION: z.string().min(1),
  VITE_ENABLE_DEVTOOLS: z
    .string()
    .transform((val) => val === "true")
    .default("false"),
  VITE_SENTRY_DSN: z.string().optional(),
});

type Env = z.infer<typeof envSchema>;

function validateEnv(): Env {
  const parsed = envSchema.safeParse(import.meta.env);

  if (!parsed.success) {
    const formatted = parsed.error.format();
    const errorMessages = Object.entries(formatted)
      .filter(([key]) => key !== "_errors")
      .map(([key, value]) => {
        const errors = (value as { _errors?: string[] })._errors;
        return `  ${key}: ${errors?.join(", ") ?? "Invalid"}`;
      })
      .join("\n");

    throw new Error(
      `Environment validation failed:\n${errorMessages}\n\nCheck your .env file against .env.example`,
    );
  }

  return parsed.data;
}

export const env = validateEnv();

export const isDev = import.meta.env.DEV;
export const isProd = import.meta.env.PROD;
export const isMockApi = env.VITE_IS_MOCK_API;
